// A failed or stalled captcha must finish as invalid, never leave the form busy.
export const validateCaptcha = ({ execute, verify, callback, timeoutMs = 20000 }) => {
	let settled = false;
	const finish = ( isValid ) => {
		if( settled ) {
			return;
		}
		settled = true;
		clearTimeout( timer );
		callback({ isValid: isValid === true });
	};
	const timer = setTimeout( () => {
		finish( false );
	}, timeoutMs );

	Promise.resolve().then( () => {
		return execute();
	}).then( token => {
		if( settled ) {
			return;
		}
		if( typeof token !== 'string' || token.length === 0 ) {
			finish( false );
			return;
		}
		verify( token, finish );
	}).catch( () => {
		finish( false );
	});

	return () => {
		settled = true;
		clearTimeout( timer );
	};
};
